import React, {Suspense, useRef, useState} from 'react';

// importing the VideoJS Functional component
import VideoJS from './VideoJS'
import 'video.js/dist/video-js.css';
import "videojs-youtube";

const App2 = () => {
    const playerReference = React.useRef(null);

    var inputLink = localStorage.getItem('videolink');
    const videoJsOptions = {
        autoplay: true,
        controls: true,
        responsive: true,
        fluid: true,
        sources: [{
            "src": inputLink,
            "type": "video/youtube"
        }]
    };

    const playerReady = (player) => {
        playerReference.current = player;

        // handling video player
        player.on('waiting', () => {
            player.log('Video Player is waiting');
        });
        player.on('dispose', () => {
            player.log('Video player will dispose');
        });
    };

        return (
            <>
            <div style={{
                width:"100%",
                height:"100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                backgroundColor: "black"
            }}>
                <VideoJS options={videoJsOptions} onReady={playerReady}/>
            </div>
            </>
        )
}


export default App2;